import React, { type FC } from "react";

import { PriorityAlert } from "components/Shared/PriorityAlert/PriorityAlert";

import { useTimezoneDiffText } from "./useTimezoneDiffText";

interface TimezoneDiffAlertProps {
    clientTimezone?: string;
}

export const TimezoneDiffAlert: FC<TimezoneDiffAlertProps> = ({ clientTimezone }) => {
    const { shouldShowTimezoneDiff, timezoneDiffText } = useTimezoneDiffText({ clientTimezone });

    if (!clientTimezone || !shouldShowTimezoneDiff || !timezoneDiffText) {
        return null;
    }

    return (
        <PriorityAlert priority="normal">
            {timezoneDiffText}
        </PriorityAlert>
    );
};
